import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const TrustsMobileField = (props) => {
  let { required, name, label } = props;

  if (name === undefined) name = "";
  if (required === undefined) required = false;

  const isValid = (tel) => {
    const re = /^[0-9]{8,15}$/;
    return (tel || !required) &&
      (re.test(tel) || (!required && (tel === undefined || tel?.length === 0)))
      ? undefined
      : "A valid mobile number must be provided";
  };

  const stripSpaces = (value) => {
    return value && value.replace(/ /g, "");
  };
  return (
    <Field
      name={name}
      validate={isValid}
      label={label}
      autoComplete="tel-national"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      parse={stripSpaces}
      fullWidth
      inputProps={{ maxLength: 15 }}
    />
  );
};

export default TrustsMobileField;
